import { useEffect, useRef } from "react";

import i18n from "../../i18n";

export function getDefaultDocumentTitle() {
  return i18n.t("Applicant Portal — Certn");
}

export function useDocumentTitle(title: string | null) {
  const hasSetTitle = useRef(false);

  useEffect(() => {
    if (title === null) {
      if (hasSetTitle.current) {
        document.title = getDefaultDocumentTitle();
        hasSetTitle.current = false;
      }
      return;
    }

    document.title = title;
    hasSetTitle.current = true;
  }, [title]);

  useEffect(() => {
    return () => {
      document.title = getDefaultDocumentTitle();
    };
  }, []);
}
